import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg/Svg.definition';
import { chameleonAvatarV2 } from '../Avatar/Avatar.definition';
import { chameleonChipV2 } from './ChipV2.definition';
import { chameleonRoundButton } from '../RoundButton/RoundButton.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonSvg({ prefix }), chameleonAvatarV2({ prefix }), chameleonChipV2({ prefix }), chameleonRoundButton({ prefix }));
}
